import React from 'react'
import PropTypes from 'prop-types'
import AceContext from './AceContext'

class AceContentProvider extends React.Component {
  static propTypes = {
    content: PropTypes.object.isRequired,
  }

  static defaultProps = {
    content: {},
  }

  render() {
    const { children, ...props } = this.props

    return <AceContext.Provider value={props}>{children}</AceContext.Provider>
  }
}

export default AceContentProvider
